module.exports = __webpack_public_path__ + "chatbotinfost/webchat_static/media/DroidKufi-Regular.e22da300.woff";